/** IANA zone of the browser, sent with server-rendered PDFs so their dates match the user's clock. */
export function getBrowserTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}
